import { AxisIndex as i } from "./CuttingPlaneController.types.mjs";
import { CuttingPlaneInfo as a } from "./CuttingPlaneInfo.mjs";
class _ {
  constructor(t, e) {
    this.setCuttingPlaneVisibility = async (n, s) => {
      if (!this._cuttingSections[this._getCuttingSectionIndex(s)])
        return this._pendingFuncs.visibility = () => {
          this.setCuttingPlaneVisibility(n, s);
        }, Promise.resolve();
      if (this._viewer.delayCapping(), n) {
        const c = this._ensurePlaneInfo(s);
        c.plane === null && (c.plane = this._generateCuttingPlane(s), c.referenceGeometry = this._generateReferenceGeometry(s)), await this._setSection(s);
      } else
        await this.refreshPlaneGeometry();
      const o = this.getCount(), r = this._isActive(s);
      if (o > 0 && !r)
        return this._activatePlanes();
      if (r && o == 0)
        return this._deactivateAxis(s);
    }, this._cuttingSections = [], this._modelBounding = new e.Box(), this._planeInfo = {}, this._cadViewActivated = !1, this._showReferenceGeometry = !0, this._useIndividualCuttingSections = !0, this._boundingBoxUpdate = !1, this._faceSelection = null, this._modelStructureReady = !1, this._pendingFuncs = {}, this._viewer = t, this._bundle = e, this.resetCuttingPlanes(), this._viewer.setCallbacks({
      modelStructureReady: () => {
        const n = [];
        n.push(this._initSection()), this._modelStructureReady = !0, n.push(this._updateBoundingBox()), Promise.all(n);
      },
      partsVisibilityHidden: () => {
        this._updateBoundingBox();
      },
      partsVisibilityShown: () => {
        this._updateBoundingBox();
      },
      hwfParseComplete: () => {
        this._updateBoundingBox();
      },
      _modelSwitched: () => this._updateBoundingBox().then(() => {
        this.resetCuttingPlanes();
      }),
      _resetAssemblyTreeBegin: async () => {
        await this._clearCuttingSections();
      }
    });
  }
  _ensurePlaneInfo(t) {
    let e = this._planeInfo[t];
    return e === void 0 && (e = new a(), this._planeInfo[t] = e), e;
  }
  _setStatus(t, e) {
    this._ensurePlaneInfo(t).status = e;
  }
  async _updateBoundingBox() {
    if (!this._boundingBoxUpdate && this._modelStructureReady) {
      this._boundingBoxUpdate = !0;
      const t = await this._viewer.model.getModelBounding(!0, !1), e = this._modelBounding.min.equalsWithTolerance(t.min, 0.01), n = this._modelBounding.max.equalsWithTolerance(t.max, 0.01);
      if (!e || !n) {
        this._modelBounding = t, this._ensurePlaneInfo(i.X).updateReferenceGeometry = !0, this._ensurePlaneInfo(i.Y).updateReferenceGeometry = !0, this._ensurePlaneInfo(i.Z).updateReferenceGeometry = !0, this._ensurePlaneInfo(i.FACE).updateReferenceGeometry = !0;
        const s = [
          this._isActive(i.X),
          this._isActive(i.Y),
          this._isActive(i.Z),
          this._isActive(i.FACE)
        ];
        this._storePlanes(), this._clearCuttingSections().then(() => this._restorePlanes(s));
      }
      this._boundingBoxUpdate = !1;
    }
  }
  _resetAxis(t) {
    delete this._planeInfo[t], t === i.FACE && (this._faceSelection = null);
  }
  resetCuttingPlanes() {
    return this._resetAxis(i.X), this._resetAxis(i.Y), this._resetAxis(i.Z), this._resetAxis(i.FACE), this._useIndividualCuttingSections = !0, this._showReferenceGeometry = !0, this._faceSelection = null, this._clearCuttingSections();
  }
  async _initSection() {
    const t = await this._viewer.model.getModelBounding(!0, !1);
    this._modelBounding = t.copy(), this._cuttingSections[i.X] = this._viewer.cuttingManager.getCuttingSection(i.X), this._cuttingSections[i.Y] = this._viewer.cuttingManager.getCuttingSection(i.Y), this._cuttingSections[i.Z] = this._viewer.cuttingManager.getCuttingSection(i.Z), this._cuttingSections[i.FACE] = this._viewer.cuttingManager.getCuttingSection(i.FACE), this._triggerPendingFuncs();
  }
  _triggerPendingFuncs() {
    this._pendingFuncs.inverted && (this._pendingFuncs.inverted(), delete this._pendingFuncs.inverted), this._pendingFuncs.visibility && (this._pendingFuncs.visibility(), delete this._pendingFuncs.visibility);
  }
  toggle(t) {
    var o;
    const e = this._getAxis(t);
    if (e === null)
      return Promise.resolve();
    let n = !1;
    if (e === i.FACE) {
      const r = this._viewer.selectionManager.getLast();
      r !== null && r.isFaceSelection() ? (n = !0, this._faceSelection = r) : n = !1;
    }
    const s = [];
    switch (this._ensurePlaneInfo(e).status) {
      case 0:
        e === i.FACE ? n && s.push(
          (o = this._cuttingSections[e]) == null ? void 0 : o.clear().then(() => (this._cadViewActivated = !1, this._setStatus(
            e,
            1
            /* Visible */
          ), this.setCuttingPlaneVisibility(!0, e)))
        ) : (this._setStatus(
          e,
          1
          /* Visible */
        ), s.push(this.setCuttingPlaneVisibility(!0, e)));
        break;
      case 1:
        this._setStatus(
          e,
          2
          /* Inverted */
        ), s.push(this.setCuttingPlaneInverted(e));
        break;
      case 2:
        this._setStatus(
          e,
          0
          /* Hidden */
        ), s.push(this.setCuttingPlaneVisibility(!1, e));
        break;
    }
    return Promise.all(s);
  }
  // sums up count from all cutting sections
  getCount() {
    let t = 0;
    for (let e = 0; e < this._cuttingSections.length; e++) {
      const n = this._cuttingSections[e];
      n && (t += n.getCount());
    }
    return t;
  }
  setCuttingPlaneInverted(t) {
    if (!this._cuttingSections[this._getCuttingSectionIndex(t)])
      return this._pendingFuncs.inverted = () => {
        this.setCuttingPlaneInverted(t);
      }, Promise.resolve();
    this._viewer.delayCapping();
    const e = this._getPlaneIndex(t), n = this._cuttingSections[this._getCuttingSectionIndex(t)], s = n ? n.getPlane(e) : null;
    return n && s ? (s.normal.negate(), s.d *= -1, n.updatePlane(e, s)) : Promise.resolve();
  }
  toggleReferenceGeometry() {
    return this._showReferenceGeometry = !this._showReferenceGeometry, this.refreshPlaneGeometry();
  }
  refreshPlaneGeometry() {
    return this._storePlanes(), this._clearCuttingSections().then(() => this._restorePlanes());
  }
  toggleCuttingMode() {
    this._storePlanes();
    const t = this._clearCuttingSections();
    return this._useIndividualCuttingSections = !this._useIndividualCuttingSections, t.then(() => this._restorePlanes());
  }
  cadViewActivated() {
    this._cadViewActivated = !0, this._setStatus(
      i.FACE,
      0
      /* Hidden */
    );
  }
  /* Helper functions */
  _isActive(t) {
    const e = this._cuttingSections[this._getCuttingSectionIndex(t)];
    return e ? e.isActive() : !1;
  }
  _deactivateAxis(t) {
    const e = this._cuttingSections[this._getCuttingSectionIndex(t)];
    return e ? e.deactivate() : Promise.resolve();
  }
  _getCuttingSectionIndex(t) {
    return this._useIndividualCuttingSections ? t : 0;
  }
  _clearCuttingSection(t) {
    const e = this._cuttingSections[t];
    return e ? e.clear() : Promise.resolve();
  }
  _clearCuttingSections() {
    const t = [];
    return t.push(this._clearCuttingSection(i.X)), t.push(this._clearCuttingSection(i.Y)), t.push(this._clearCuttingSection(i.Z)), this._cadViewActivated || t.push(this._clearCuttingSection(i.FACE)), Promise.all(t).then(null);
  }
  _activatePlane(t) {
    const e = this._cuttingSections[t];
    if (e && e.getCount()) {
      const n = e.activate();
      return n === null ? Promise.resolve() : n;
    }
    return Promise.resolve();
  }
  _activatePlanes(t) {
    const e = [];
    return (!t || t[0]) && e.push(this._activatePlane(i.X)), (!t || t[1]) && e.push(this._activatePlane(i.Y)), (!t || t[2]) && e.push(this._activatePlane(i.Z)), (!t || t[3]) && e.push(this._activatePlane(i.FACE)), Promise.all(e);
  }
  _getAxis(t) {
    switch (t) {
      case "x":
        return i.X;
      case "y":
        return i.Y;
      case "z":
        return i.Z;
      case "face":
        return i.FACE;
      default:
        return null;
    }
  }
  _getPlaneIndex(t) {
    if (this._useIndividualCuttingSections) {
      const e = this._cuttingSections[this._getCuttingSectionIndex(t)];
      if (e && e.getPlane(0))
        return 0;
    } else {
      const e = this._cuttingSections[0];
      if (e)
        for (let n = 0; n < e.getCount(); n++) {
          const s = e.getPlane(n);
          let o;
          if (this._faceSelection && (o = this._faceSelection.getFaceEntity().getNormal()), s && (s.normal.x && t == i.X || s.normal.y && t == i.Y || s.normal.z && t == i.Z || t == i.FACE && o && s.normal.equals(o)))
            return n;
        }
    }
    return -1;
  }
  _setSection(t) {
    const e = this._planeInfo[t];
    if (e !== void 0 && e.plane !== null) {
      const n = this._cuttingSections[this._getCuttingSectionIndex(t)], s = this._showReferenceGeometry ? e.referenceGeometry : void 0;
      if (n)
        return n.addPlane(e.plane, s);
    }
    return Promise.resolve();
  }
  _restorePlane(t) {
    const e = this._planeInfo[t];
    return e !== void 0 && e.plane !== null && e.status !== 0 ? ((e.referenceGeometry === null || e.updateReferenceGeometry) && (e.referenceGeometry = this._generateReferenceGeometry(t)), this._setSection(t)) : Promise.resolve();
  }
  _restorePlanes(t) {
    return this._restorePlane(i.X), this._restorePlane(i.Y), this._restorePlane(i.Z), this._restorePlane(i.FACE), this._activatePlanes(t);
  }
  _storePlane(t) {
    const e = this._cuttingSections[this._getCuttingSectionIndex(t)], n = this._ensurePlaneInfo(t);
    if (n.plane = null, n.referenceGeometry = null, e && e.getCount() > 0 && n.status !== 0) {
      const s = this._getPlaneIndex(t), o = e.getPlane(s), r = e.getReferenceGeometry(s);
      this._cadViewActivated && t === i.FACE || (n.plane = o, n.referenceGeometry = r);
    }
  }
  _storePlanes() {
    this._storePlane(i.X), this._storePlane(i.Y), this._storePlane(i.Z), this._storePlane(i.FACE);
  }
  _generateReferenceGeometry(t) {
    let e = [], n;
    if (t == i.FACE) {
      if (this._faceSelection) {
        const s = this._faceSelection.getFaceEntity().getNormal(), o = this._faceSelection.getPosition();
        e = this._viewer.cuttingManager.createReferenceGeometryFromFaceNormal(
          s,
          o,
          this._modelBounding
        );
      }
    } else {
      switch (t) {
        case i.X:
          n = this._bundle.Axis.X;
          break;
        case i.Y:
          n = this._bundle.Axis.Y;
          break;
        case i.Z:
          n = this._bundle.Axis.Z;
          break;
      }
      n !== void 0 && (e = this._viewer.cuttingManager.createReferenceGeometryFromAxis(n, this._modelBounding));
    }
    return e;
  }
  _generateCuttingPlane(t) {
    const e = new this._bundle.Plane();
    switch (t) {
      case i.X:
        e.normal.set(1, 0, 0), e.d = -this._modelBounding.max.x;
        break;
      case i.Y:
        e.normal.set(0, 1, 0), e.d = -this._modelBounding.max.y;
        break;
      case i.Z:
        e.normal.set(0, 0, 1), e.d = -this._modelBounding.max.z;
        break;
      case i.FACE:
        if (this._faceSelection) {
          const n = this._faceSelection.getFaceEntity().getNormal(), s = this._faceSelection.getPosition();
          e.setFromPointAndNormal(s, n);
        } else
          return null;
    }
    return e;
  }
}
export {
  _ as CuttingPlaneController
};
//# sourceMappingURL=CuttingPlaneController.mjs.map
